import { z } from 'zod';

/**
 * An enum representing the possible statuses of an event.
 * - `pending`: The event is pending and has not been sent yet.
 * - `sent`: The event has been sent.
 * - `delivered`: The event has been delivered.
 * - `failed`: The event has failed to be delivered.
 */
export const eventStatusEnum = z.enum([
  'pending',
  'sent',
  'delivered',
  'failed',
]);


/**
 * An enum representing the possible statuses of an event.
 * - `pending`: The event is pending and has not been sent yet.
 * - `sent`: The event has been sent.
 * - `delivered`: The event has been delivered.
 * - `failed`: The event has failed to be delivered.
 */
export type EventStatusEnum = z.infer<typeof eventStatusEnum>;
